import {EndpointBuilder} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import {createApi} from '@reduxjs/toolkit/query/react';
import {createContentEndpoint} from './endpoints/content.endpoints';
import {umbracoCdnBaseQueryFn} from './umbracoCdnBaseQuery';

export type UmbracoCdnApiEndpointBuilder = EndpointBuilder<
  typeof umbracoCdnBaseQueryFn,
  never,
  'umbracoCdnApi'
>;

// Define a service using a base URL and expected endpoints
export const umbracoCdnApi = createApi({
  reducerPath: 'umbracoCdnApi',
  baseQuery: umbracoCdnBaseQueryFn,
  endpoints: builder => ({
    ...createContentEndpoint(builder),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazySearchContentQuery,
  useLazyFilterSearchContentQuery,
  useCountSavedContentMutation,
} = umbracoCdnApi;
